import { render } from "./Transfer.vue?vue&type=template&id=163176e6"
import script from "./Transfer.vue?vue&type=script&lang=js"
export * from "./Transfer.vue?vue&type=script&lang=js"
script.render = render

export default script